import { faKey } from "@fortawesome/free-solid-svg-icons/faKey";
import { faLock } from "@fortawesome/free-solid-svg-icons/faLock";
import { faTimes } from "@fortawesome/free-solid-svg-icons/faTimes";
import { faUnlockKeyhole } from "@fortawesome/free-solid-svg-icons/faUnlockKeyhole";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogProps,
} from "@mui/material";
import { SenhaModal } from "app/types/cliente/RespostaCredito";
import clsx from "clsx";
import React, { useState } from "react";
import { PaperArrastavel } from "../dialog-arrastavel/PaperArrastavel";

const estilosBotoes = require("../../estilos/botoes.module.scss").default;
const estilosFormulario = require("../../estilos/formulario.module.scss").default;
const estilosInputs = require("../../estilos/inputs.module.scss").default;

export type Autorizar = {
  permissoes: string[];
  codigoSenha: string;
};

export type ModalPermissaoSenhaProps = {
  senhaModal: SenhaModal;
  onClose:() => void;
  onAutorizar: (autorizar: Autorizar) => void;
};

export const ModalPermissaoSenha = (props: ModalPermissaoSenhaProps) => {
  const [senha, setSenha] = useState("");
  const [scroll, setScroll] = useState<DialogProps["scroll"]>("paper");

  const botaoCloseModal =
  (
    <button className={clsx(estilosBotoes.BotaoFecharModal)} title="Fechar"
      onClick={props.onClose}>
        <FontAwesomeIcon icon={faTimes} />
    </button>
  );


  
      // <div>
      //   <a onClick={props.onClose} >
      //     <FontAwesomeIcon icon={faTimes} cursor={"pointer"}
      //       className={estiloModalPermissaoSenha.exit}
      //       opacity={0.2}
      //     />
      //   </a>
      // </div>

  const tituloDialog =
    <div className={estilosFormulario.tituloModal} data-arrastar-dialog>
        <i style={{ fontWeight: "700", padding:"5px"}}><FontAwesomeIcon icon={faLock} /></i>
        <label style={{fontSize:'large'}}>Permissão</label>
        {botaoCloseModal}
    </div>

    const botaoFechar =
      <button className={estilosBotoes.botaoPrimario} 
        onClick={props.onClose}
        >Fechar</button>

    const botaoAutorizar =
      <button className={estilosBotoes.botaoPrimario}
            onClick={(e) => {
              props.onAutorizar({
                permissoes: props.senhaModal?.Permissoes.map(
                  (value) => value.NomeInterno
                ),
                codigoSenha: senha,
              });
            }}
          >Autorizar
      </button>

    const botoesAcoesDialog = 
      <DialogActions>
          {botaoAutorizar}
           {botaoFechar} 
      </DialogActions>
   
    const corpoDoDialog = 
      <DialogContent dividers={scroll === "body"} style={{ padding: "15px" }}>
        <div>
          {props.senhaModal?.Permissoes?.length > 0 && 
          <>
          <h4 style={{ fontWeight: 700 }}>Informe senha com as seguintes permissões</h4> 
          {props.senhaModal?.Permissoes?.map((value) => (
            <ul key={value.NomeInterno}>
              <li>{value.Nome}</li>
            </ul>
          ))}
          </>
        }


          <div className={estilosFormulario.separador} />
          <section >
            <label className={estilosInputs.labelObrigatorio} >Senha</label>
            <input className={estilosInputs.inputPadrao}  
                style={{marginLeft: '4px'}} 
                type="password" 
                autoComplete="off"
                aria-autocomplete="none"
                value={(senha) ?? ""} 
                onChange={(e) => setSenha(e.target.value)}
                />
          </section>
          
          <div className={estilosFormulario.separador} />
        </div>
        {botoesAcoesDialog}
      </DialogContent>


  return (
    <>
      <Dialog className={estilosFormulario.dialogModalSenha}
            open={true}
            onClose={props.onClose}
            scroll={scroll}
            PaperComponent={PaperArrastavel}>
        {tituloDialog}
        {corpoDoDialog}
      </Dialog>
    </>
  );
};
